import axios from "axios";
import { isNative, getToken } from "./authToken";

/**
 * Platform-aware auth for the DEFAULT axios instance (used directly by many
 * components). Web: the same-origin HttpOnly session cookie is sent
 * automatically. Native: attach the Bearer token from the OS secure store.
 * Imported once from index.js so it applies before any component request.
 */
axios.defaults.withCredentials = !isNative;

axios.interceptors.request.use(async (config) => {
  if (isNative) {
    const token = await getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});
